import { Component, OnInit } from '@angular/core';
import { StoreTypeService } from '../store-type.service';
import { StoreType } from '../store-type';
import { Router } from '@angular/router';

@Component({
  selector: 'app-store-type',
  templateUrl: './store-type.component.html',
  styleUrls: ['./store-type.component.css'],
  providers: [StoreTypeService]

})
export class StoreTypeComponent implements OnInit {

   storeTypes: StoreType[];

  constructor(private storeTypeService: StoreTypeService, private router: Router) { }

  ngOnInit() {
 
	  this.storeTypeService.getStoreTypeList().subscribe(response=>{this.storeTypes=response['data']});

  }
  clicked():void{
	   this.router.navigate(['/store-type-crud']); 	
  }

  clickedId(id: any){
    console.log("ha");
     this.router.navigate(['/store-type-crud/',id]);
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/store_types/store-type/store-type.component.ts